import React, { Component } from 'react'
import { connect } from 'dva'
import { Table, Row, Col, DatePicker, Tooltip, Space } from 'antd'
import { ExportOutlined, QuestionCircleOutlined } from '@ant-design/icons'
import './styles.less'
import moment from 'moment'
import Config from '../../config/Config'
import NumericConversion from '../../utils/utils'
import { getToken } from '../../utils/authority'
import qs from 'query-string'

import BasicLayout from '../../components/BasicLayout'
import { routerRedux } from 'dva/router'
import { METRIC_TIPS } from '../../constants/metricTips'

const { RangePicker } = DatePicker

function disabledDate(current) {
  let time = moment().add(1, 'days').format('YYYY-MM-DD');
  return current && !moment(current).isBefore(time);
}

// ========== 筛选器配置常量 ==========
// 筛选器键名定义
const FILTER_KEYS = {
  METRIC: 'metric',              // 维度（单选）
  PLATFORMS: 'platforms',        // 流媒体平台（多选）
  PUBLISHER: 'publisher',        // 经营者（单选）
  GAME_SEGMENTS: 'gameSegments', // 游戏平台（多选）
  GENRES: 'genres',              // 游戏类型（多选）
  DEVELOPERS: 'developers',      // 发展商（多选）
  TIME_PERIOD: 'timePeriod',     // 时间段（单选）
  LICENSED: 'licensed'           // 注册许可（单选）
}

// 筛选器类型配置 - 定义每个筛选器的选择类型和对应的API参数名
const FILTER_CONFIG = {
  [FILTER_KEYS.METRIC]: { type: 'single', apiKey: 'cate' },
  [FILTER_KEYS.PLATFORMS]: { type: 'multiple', apiKey: 'platformID' },
  [FILTER_KEYS.PUBLISHER]: { type: 'single', apiKey: 'Operator' },
  [FILTER_KEYS.GAME_SEGMENTS]: { type: 'multiple', apiKey: 'Platform' },
  [FILTER_KEYS.GENRES]: { type: 'multiple', apiKey: 'gameGenre' },
  [FILTER_KEYS.DEVELOPERS]: { type: 'single', apiKey: 'DeveloperID' },
  [FILTER_KEYS.TIME_PERIOD]: { type: 'single', apiKey: null },
  [FILTER_KEYS.LICENSED]: { type: 'single', apiKey: 'licensed' }
}

// 默认筛选器值
const DEFAULT_FILTERS = {
  [FILTER_KEYS.METRIC]: 'sumAnchor',
  [FILTER_KEYS.PLATFORMS]: [],
  [FILTER_KEYS.PUBLISHER]: null,
  [FILTER_KEYS.GAME_SEGMENTS]: [],
  [FILTER_KEYS.GENRES]: [],
  [FILTER_KEYS.DEVELOPERS]: null,
  [FILTER_KEYS.TIME_PERIOD]: '0',
  [FILTER_KEYS.LICENSED]: 'all'
}

class GameList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      // 使用语义化的筛选器状态
      filters: { ...DEFAULT_FILTERS },
      // 日期范围
      dateRange: {
        startDate: null,
        endDate: null
      },
      showMore: false,
    }
  }

  // 生成筛选器目录配置（动态生成）
  getCatalog = () => {
    const { segmentList = [], genreList = [] } = this.props
    return [
      {
        key: FILTER_KEYS.METRIC,
        nameEN: 'Metric',
        nameCN: '维度',
        list: [
          { nameEN: 'Live Streamers', nameCN: '主播数量', value: 'sumAnchor' },
          { nameEN: 'Hours Streamed', nameCN: '主播时长', value: 'sumLenth' },
          { nameEN: 'Subscribers', nameCN: '游戏粉丝数', value: 'sumFans' },
          { nameEN: 'Tips', nameCN: '游戏打赏收入', value: 'sumGift' },
          { nameEN: 'Heat Index', nameCN: '游戏热力值', value: 'sumHot' },
          { nameEN: 'Niko Index', nameCN: 'NIKO指数', value: 'sumNiko' }
        ]
      },
      {
        key: FILTER_KEYS.PLATFORMS,
        nameEN: 'Platform',
        nameCN: '流媒体网站',
        list: [
          { nameEN: 'DouYu', value: '103' },
          { nameEN: 'HuYa', value: '102' },
          { nameEN: 'Bilibili', value: '101' },
        ]
      },
      {
        key: FILTER_KEYS.PUBLISHER,
        nameEN: 'Publisher',
        nameCN: '经营者',
        list: [
          { nameEN: 'Tencent', value: 'Tencent' },
          { nameEN: 'NetEase', value: 'Netease' },
          { nameEN: 'Steam', value: 'Steam' },
          { nameEN: 'miHoYo', value: 'Mihoyo Game' },
          { nameEN: 'EA', value: 'EA' },
          { nameEN: 'Ubisoft', value: 'Ubisoft' },
          { nameEN: 'Perfect World', value: 'Perfect World' },
          { nameEN: 'Nexon', value: 'Nexon' },
          { nameEN: 'Blizzard', value: 'Blizzard' },
          { nameEN: 'SCE', value: 'SCE' },
          { nameEN: 'Nintendo', value: 'Nintendo' },
          { nameEN: 'Shengqu', value: 'Shengqu' },
          { nameEN: '37 Game', value: '37 Game' },
          { nameEN: '4399 Game', value: '4399 Game' },
          { nameEN: 'Leiting Game', value: 'Leiting Game' },
          { nameEN: 'Activison', value: 'Activison' },
          { nameEN: 'Take-Two', value: 'Take-Two' },
          { nameEN: 'Bilibili', value: 'Bilibili' },
          { nameEN: 'Other', value: 'other' },
        ]
      },
      {
        key: FILTER_KEYS.GAME_SEGMENTS,
        nameEN: 'Game Platform',
        nameCN: '平台',
        list: [
          ...(segmentList || []).map(segment => ({
            nameEN: segment.name,
            value: segment.id
          }))
        ]
      },
      {
        key: FILTER_KEYS.GENRES,
        nameEN: 'Genre',
        nameCN: '类型',
        list: [
          ...(genreList || []).map(genre => ({
            nameEN: genre.name,
            value: genre.id
          }))
        ]
      },
      {
        key: FILTER_KEYS.DEVELOPERS,
        nameEN: 'Developer',
        nameCN: '发展商',
        list: [
          { nameEN: 'Tencent', value: 615 },
          { nameEN: 'NetEase', value: 617 },
          { nameEN: 'Steam', value: 616 },
          { nameEN: 'miHoYo', value: 627 },
          { nameEN: 'EA', value: 622 },
          { nameEN: 'Ubisoft', value: 690 },
          { nameEN: 'Perfect World', value: 618 },
          { nameEN: 'Nexon', value: 766 },
          { nameEN: 'Blizzard', value: 621 },
          { nameEN: 'SCE', value: 653 },
          { nameEN: 'Nintendo', value: 647 },
          { nameEN: 'Shengqu', value: 623 },
          { nameEN: '37 Game', value: 686 },
          { nameEN: '4399 Game', value: 752 },
          { nameEN: 'Leiting Game', value: 691 },
          { nameEN: 'Activison', value: 1065 },
          { nameEN: 'Take-Two', value: 790 },
          { nameEN: 'Bilibili', value: 631 },
          { nameEN: 'Other', value: 'other' },
        ]
      },
      {
        key: FILTER_KEYS.TIME_PERIOD,
        nameEN: 'Timeframe',
        nameCN: '时间段',
        list: [
          { nameEN: 'Day', nameCN: '昨天', value: '0' },
          { nameEN: 'Last 7 Days', nameCN: '近一周', value: '1' },
          { nameEN: 'Last 30 Days', nameCN: '近一月', value: '2' },
          { nameEN: 'Custom Range', nameCN: '自定义', value: '3' }
        ]
      },
      {
        key: FILTER_KEYS.LICENSED,
        nameEN: 'Licensing Status',
        nameCN: '注册许可',
        list: [
          { nameEN: 'Licensed', nameCN: '已注册', value: 'licensed' },
          { nameEN: 'Unlicensed', nameCN: '未注册', value: 'unlicensed' }
        ]
      }
    ]
  }

  componentDidMount() {
    const params = this.buildQueryParams()
    this.props.dispatch({
      type: 'gameList/apiGetRankList',
      payload: {
        page: 1,
        ...params
      }
    })
    this.props.dispatch({
      type: 'gameList/apiGetDeveloper'
    })
    this.props.dispatch({
      type: 'gameList/apiGetSegments'
    })
    this.props.dispatch({
      type: 'gameList/apiGetGenres'
    })
  }

  componentDidUpdate(prevProps, prevState) {
    const { filters, dateRange } = this.state
    const { followedStatus } = this.props

    // 检查筛选条件是否变化
    const filtersChanged = JSON.stringify(prevState.filters) !== JSON.stringify(filters)
    const dateChanged = JSON.stringify(prevState.dateRange) !== JSON.stringify(dateRange)
    const followedChanged = prevProps.followedStatus !== followedStatus && followedStatus

    if (filtersChanged || dateChanged || followedChanged) {
      const params = this.buildQueryParams()
      this.props.dispatch({
        type: 'gameList/apiGetRankList',
        payload: { page: 1, perPage: this.props.perPage, ...params }
      })
    }
  }

  /**
   * 构建API查询参数
   * 将语义化的filters对象转换为API需要的参数格式
   */
  buildQueryParams = () => {
    const { filters, dateRange } = this.state
    const params = {}

    // 遍历筛选器配置，构建参数
    Object.keys(FILTER_CONFIG).forEach(filterKey => {
      const config = FILTER_CONFIG[filterKey]
      const value = filters[filterKey]

      if (config.apiKey && value !== null && value !== undefined) {
        if (config.type === 'multiple' && Array.isArray(value) && value.length > 0) {
          // 多选：数组转逗号分隔字符串
          params[config.apiKey] = value.join(',')
        } else if (config.type === 'single' && value) {
          // 单选：直接赋值
          params[config.apiKey] = value
        }
      }
    })

    // 添加日期参数
    if (dateRange.startDate) {
      params.startDate = dateRange.startDate
      params.endDate = dateRange.endDate
    }

    return params
  }

  /**
   * 处理单选筛选器
   * @param {string} filterKey - 筛选器键名
   * @param {*} value - 选中的值
   */
  handleSingleSelect = (filterKey, value) => {
    const { filters } = this.state

    // 如果点击已选中的值，则取消选择
    const newValue = filters[filterKey] === value ? null : value

    this.setState({
      filters: {
        ...filters,
        [filterKey]: newValue
      }
    })
  }

  /**
   * 处理多选筛选器
   * @param {string} filterKey - 筛选器键名
   * @param {*} value - 选中的值
   */
  handleMultipleSelect = (filterKey, value) => {
    const { filters } = this.state
    const currentValues = filters[filterKey] || []

    let newValues
    if (value === null) {
      // 点击"All"，清空所有选择
      newValues = []
    } else if (currentValues.includes(value)) {
      // 取消选择
      newValues = currentValues.filter(v => v !== value)
    } else {
      // 添加选择
      newValues = [...currentValues, value]
    }

    this.setState({
      filters: {
        ...filters,
        [filterKey]: newValues
      }
    })
  }

  /**
   * 处理时间段选择
   * @param {string} timePeriod - 时间段值
   */
  handleTimePeriodSelect = (timePeriod) => {
    const { filters } = this.state
    let dateRange = { startDate: null, endDate: null }

    // 根据时间段计算日期范围
    if (timePeriod === '1') {
      // 近一周
      dateRange.startDate = moment().subtract(7, 'days').format('YYYY-MM-DD')
      dateRange.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD')
    } else if (timePeriod === '2') {
      // 近一月
      dateRange.startDate = moment().subtract(30, 'days').format('YYYY-MM-DD')
      dateRange.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD')
    }
    // 如果是 '0'（昨天）或 '3'（自定义），则dateRange保持null

    this.setState({
      filters: {
        ...filters,
        [FILTER_KEYS.TIME_PERIOD]: timePeriod
      },
      dateRange
    })
  }

  /**
   * 统一的筛选器点击处理
   * @param {string} filterKey - 筛选器键名
   * @param {*} value - 选中的值
   */
  handleFilterClick = (filterKey, value) => {
    // 特殊处理：跳转到其他页面
    if (filterKey === FILTER_KEYS.PUBLISHER && value === 'other') {
      this.props.dispatch(routerRedux.push('/company'))
      return
    }
    if (filterKey === FILTER_KEYS.DEVELOPERS && value === 'other') {
      this.props.dispatch(routerRedux.push('/developer'))
      return
    }

    // 根据筛选器类型选择处理方式
    const config = FILTER_CONFIG[filterKey]

    if (filterKey === FILTER_KEYS.TIME_PERIOD) {
      // 时间段特殊处理
      this.handleTimePeriodSelect(value)
    } else if (config.type === 'single') {
      this.handleSingleSelect(filterKey, value)
    } else if (config.type === 'multiple') {
      this.handleMultipleSelect(filterKey, value)
    }
  }

  /**
   * 处理自定义日期选择
   */
  handleChangeDate = (time, dateString) => {
    if (time) {
      this.setState({
        dateRange: {
          startDate: moment(time[0]).format('YYYY-MM-DD'),
          endDate: moment(time[1]).format('YYYY-MM-DD')
        }
      })
    }
  }

  /**
   * 判断筛选项是否被选中
   * @param {string} filterKey - 筛选器键名
   * @param {*} itemValue - 筛选项的值
   * @returns {boolean}
   */
  isFilterItemActive = (filterKey, itemValue) => {
    const { filters } = this.state
    const value = filters[filterKey]
    const config = FILTER_CONFIG[filterKey]

    if (config.type === 'single') {
      // 单选：直接比较
      return value === itemValue
    } else if (config.type === 'multiple') {
      // 多选：检查是否在数组中，或者两者都为空（All选项）
      return Array.isArray(value)
        ? value.includes(itemValue) || (value.length === 0 && itemValue === null)
        : false
    }
    return false
  }

  /**
   * 重置所有筛选器
   */
  handleReset = () => {
    this.setState({
      filters: { ...DEFAULT_FILTERS },
      dateRange: {
        startDate: null,
        endDate: null
      },
      showMore: false,
    })
  }

  handleJumpToDetails = (id) => {
    if (id) {
      this.props.dispatch(routerRedux.push(`/gameList/gameDetails/${id}`))
    }
  }

  handleFollowed = (record) => {
    if (record.isLike) {
      this.props.dispatch({
        type: 'gameList/apiDeleteFollowed',
        payload: { gameID: record.gameID }
      })
    } else {
      this.props.dispatch({
        type: 'gameList/apiPostFollowed',
        payload: { gameID: record.gameID }
      })
    }
  }

  handleTableChange = (pagination, filters, sorter) => {
    const params = this.buildQueryParams()
    this.props.dispatch({
      type: 'gameList/apiGetRankList',
      payload: { page: pagination.current, perPage: pagination.pageSize, ...params }
    })
  }

  handleExport = () => {
    const { page, userInfo } = this.props
    if (userInfo && userInfo.status !== 'test' && userInfo.status !== 'off') {
      const params = this.buildQueryParams()
      params.page = page

      // 移除空值
      for (let key in params) {
        if (!params[key]) {
          delete params[key]
        }
      }

      window.open(`${Config.SERVER_HOME}file?WebAuth=${getToken()}&${qs.stringify(params)}`)
      this.props.dispatch({
        type: 'user/apiPostDownloadFiles',
        payload: { userID: parseInt(userInfo.id), fileID: 6 }
      })
    } else {
      this.props.dispatch({ type: 'user/setState', payload: { forbidDownload: true } })
    }
  }

  renderTable = () => {
    const { filters } = this.state
    const { list, page, perPage, locale, pageLoading } = this.props
    const currentMetric = filters[FILTER_KEYS.METRIC]

    const pagination = {
      current: parseInt(page) || 0,
      total: (list || {}).total || 0,
      defaultCurrent: 1,
      defaultPageSize: parseInt(perPage) || 0,
      pageSize: perPage,
      showQuickJumper: true,
      position: 'bottom',
    }

    const columns = [
      {
        title: <div className={'cate_header'}>{locale === 'EN' ? 'Rank' : '排名'}</div>,
        key: 'id',
        width: '5%',
        render: (record, row, index) => {
          let key = page > 1 ? (page * perPage) - perPage + index + 1 : index + 1
          return (
            <div className="ranking">{key}</div>
          )
        }
      },
      {
        title: <div className={'cate_header no_cursor'}>{locale === 'EN' ? 'Game' : '游戏'}</div>,
        key: 'gameInfo',
        width: '20%',
        render: (record, row, index) => {
          return (
            <div className="inline" onClick={() => { this.handleJumpToDetails(record.gameID) }}>
              <div className="logo">
                {record.gameInfo && record.gameInfo.link ? <img alt={'img'} src={record.gameInfo.link} /> : null}
              </div>
              {record.gameInfo ? (<Space direction='vertical'>
                <div className="name">{record.gameInfo.gameEn}</div>
                <div className="nameCn" style={{ color: '#F4791F' }}>{record.gameInfo.game}</div>
                {record.gameInfo && record.gameInfo.isbnInfo ? (
                  <div className="name" style={{ color: '#F4791F' }}>{'Licensed'}</div>
                ) : <div className="name" style={{ color: '#2C67A4' }}>{'Unlicensed'}</div>
                }
              </Space>) : null}

            </div>
          )
        }
      },
      {
        title: <div id={'header'} onClick={() => { this.handleFilterClick(FILTER_KEYS.METRIC, 'sumAnchor') }} className={`cate_header ${currentMetric === 'sumAnchor' ? 'cate_selected' : null}`}>
          <div className="title_name">
            <Tooltip overlayClassName="tooltip" className="text_icon" title={METRIC_TIPS.sumAnchor}>
              <QuestionCircleOutlined />
            </Tooltip>
            {locale === 'EN' ? 'Live Streamers' : '主播数量'}
          </div>
          {list && list.amountDatas ? <div className={`total ${currentMetric === 'sumAnchor' ? 'total_number' : null}`}>
            {NumericConversion(list.amountDatas[0].sumAnchor)}
          </div> : null}
        </div>,
        key: 'sumAnchor',
        dataIndex: 'sumAnchor',
        width: '13%',
        align: 'right',
        render: (record, row, index) => {
          return (
            <div className="custom_txt" style={currentMetric === 'sumAnchor' ? { color: '#F4791F' } : null}>{NumericConversion(record)}</div>
          )
        }
      },
      {
        title: <div onClick={() => { this.handleFilterClick(FILTER_KEYS.METRIC, 'sumLenth') }} className={`cate_header ${currentMetric === 'sumLenth' ? 'cate_selected' : null}`}>
          <div className="title_name">
            <Tooltip overlayClassName="tooltip" className="text_icon" title={METRIC_TIPS.sumLenth}>
              <QuestionCircleOutlined />
            </Tooltip>
            {locale === 'EN' ? 'Hours Streamed' : '主播时长'}
          </div>
          {list && list.amountDatas ? <div className={`total ${currentMetric === 'sumLenth' ? 'total_number' : null}`}>{NumericConversion(list.amountDatas[0].sumLenth)}</div> : null}
        </div>,
        key: 'sumLenth',
        dataIndex: 'sumLenth',
        width: '12.4%',
        align: 'right',
        render: (record, row, index) => {
          return (
            <div className="custom_txt" style={currentMetric === 'sumLenth' ? { color: '#F4791F' } : null}>{NumericConversion(record)}</div>
          )
        }
      },
      {
        title: <div onClick={() => { this.handleFilterClick(FILTER_KEYS.METRIC, 'sumFans') }} className={`cate_header ${currentMetric === 'sumFans' ? 'cate_selected' : null}`}>
          <div className="title_name">
            <Tooltip overlayClassName="tooltip" className="text_icon" title={METRIC_TIPS.sumFans}>
              <QuestionCircleOutlined />
            </Tooltip>
            {locale === 'EN' ? 'Subscribers' : '游戏粉丝数'}
          </div>
          {list && list.amountDatas ? <div className={`total ${currentMetric === 'sumFans' ? 'total_number' : null}`}>{NumericConversion(list.amountDatas[0].avgFans)}</div> : null}
        </div>,
        key: 'avgFans',
        dataIndex: 'avgFans',
        width: '12.4%',
        align: 'right',
        render: (record, row, index) => {
          return (
            <div className="custom_txt" style={currentMetric === 'sumFans' ? { color: '#F4791F' } : null}>{NumericConversion(record)}</div>
          )
        }
      },
      {
        title: <div onClick={() => { this.handleFilterClick(FILTER_KEYS.METRIC, 'sumGift') }} className={`cate_header ${currentMetric === 'sumGift' ? 'cate_selected' : null}`}>
          <div className="title_name">
            <Tooltip overlayClassName="tooltip" className="text_icon" title={METRIC_TIPS.sumGift}>
              <QuestionCircleOutlined />
            </Tooltip>
            {locale === 'EN' ? 'Tips' : '游戏打赏收入'}
          </div>
          {list && list.amountDatas ? <div className={`total ${currentMetric === 'sumGift' ? 'total_number' : null}`}>{locale === 'EN' ? NumericConversion(list.amountDatas[0].USsumGift) : NumericConversion(list.amountDatas[0].sumGift)}</div> : null}
        </div>,
        key: 'sumGift',
        dataIndex: locale === 'EN' ? 'USsumGift' : 'sumGift',
        width: '12.4%',
        align: 'right',
        render: (record, text) => {
          return (
            <div className="custom_txt" style={currentMetric === 'sumGift' ? { color: '#F4791F' } : null}>{NumericConversion(record)}</div>
          )
        }
      },
      {
        title: <div onClick={() => { this.handleFilterClick(FILTER_KEYS.METRIC, 'sumHot') }} className={`cate_header ${currentMetric === 'sumHot' ? 'cate_selected' : null}`}>
          <div className="title_name">
            <Tooltip overlayClassName="tooltip" className="text_icon" title={METRIC_TIPS.sumHot}>
              <QuestionCircleOutlined />
            </Tooltip>
            {locale === 'EN' ? 'Heat Index' : '游戏热力值'}
          </div>
          {list && list.amountDatas ? <div className={`total ${currentMetric === 'sumHot' ? 'total_number' : null}`}>{NumericConversion(list.amountDatas[0].avgHot)}</div> : null}
        </div>,
        key: 'avgHot',
        dataIndex: 'avgHot',
        width: '12.4%',
        align: 'right',
        render: (record, text) => {
          return (
            <div className="custom_txt" style={currentMetric === 'sumHot' ? { color: '#F4791F' } : null}>{NumericConversion(record)}</div>
          )
        }
      },
      {
        title: <div onClick={() => { this.handleFilterClick(FILTER_KEYS.METRIC, 'sumNiko') }} className={`cate_header ${currentMetric === 'sumNiko' ? 'cate_selected' : null}`}>
          <div className="title_name">
            <Tooltip overlayClassName="tooltip" className="text_icon" title={METRIC_TIPS.sumNiko}>
              <QuestionCircleOutlined />
            </Tooltip>
            {locale === 'EN' ? 'Niko Index' : 'Niko指数'}
          </div>
          {list && list.amountDatas ? <div className={`total ${currentMetric === 'sumNiko' ? 'total_number' : null}`}>{NumericConversion(list.amountDatas[0].sumNiko)}</div> : null}
        </div>,
        key: 'sumNiko',
        dataIndex: 'sumNiko',
        width: '12.4%',
        align: 'right',
        render: (record, text) => {
          return (
            <div className="custom_txt" style={currentMetric === 'sumNiko' ? { color: '#F4791F' } : null}>{NumericConversion(record)}</div>
          )
        }
      },
      {
        title: <div className={'cate_header'}>Follow</div>,
        key: 'action',
        width: '80px',
        align: 'center',
        fixed: 'right',
        render: (text, record, index) => {
          return (
            <div className="followedIcon" onClick={() => { this.handleFollowed(record) }}>
              <img src={record.isLike ? require('../../assets/common/followed.png') : require('../../assets/common/unFollowed.png')} />
            </div>
          )
        }
      }
    ]

    return (
      <Table
        loading={pageLoading}
        dataSource={(list || {}).data || []}
        columns={columns}
        pagination={pagination}
        rowKey={record => record.gameID}
        bordered={true}
        onChange={this.handleTableChange}
      />
    )
  }

  render() {
    const { locale } = this.props
    const { filters, showMore } = this.state
    const catalog = this.getCatalog()

    return (
      <BasicLayout selectedKeys={['/gameList']}>
        <div className="game_list">
          <div className="top_search">
            <Row>
              {catalog.map((filterGroup, groupIndex) => {
                const filterKey = filterGroup.key
                return (
                  <Col key={filterKey} span={24}>
                    <div className="item_line">
                      <div className="title">{locale === 'EN' ? filterGroup.nameEN : filterGroup.nameCN}</div>
                      <div className="button_content">
                        {filterGroup.list.map((item, itemIndex) => {
                          // 控制显示数量
                          if (!showMore && itemIndex >= 7) {
                            return null
                          }

                          const isActive = this.isFilterItemActive(filterKey, item.value)

                          return (
                            <div
                              key={itemIndex}
                              className={`button ${isActive ? 'button_activity' : ''}`}
                              onClick={() => { this.handleFilterClick(filterKey, item.value) }}
                            >
                              {locale === 'EN' ? item.nameEN : (item.nameCN || item.nameEN)}
                            </div>
                          )
                        })}

                        {/* 展开/收起按钮 */}
                        {filterGroup.list.length > 19 && (
                          <div className={'button more'}>
                            <span onClick={() => { this.setState({ showMore: !showMore }) }}>
                              {!showMore ? (locale === 'EN' ? 'Expand' : '展开') : (locale === 'EN' ? 'Collapse' : '收起')}
                            </span>
                          </div>
                        )}

                        {/* 自定义日期选择器 */}
                        {filterKey === FILTER_KEYS.TIME_PERIOD && filters[FILTER_KEYS.TIME_PERIOD] === '3' && (
                          <RangePicker
                            format="MMM DD, YYYY"
                            placeholder={['Start Date', 'End Date']}
                            disabledDate={disabledDate}
                            onChange={this.handleChangeDate}
                            style={{ padding: '2px 14px 2px', margin: '0 13px 13px 0' }}
                          />
                        )}
                      </div>
                    </div>
                  </Col>
                )
              })}
            </Row>
          </div>

          <div className="export">
            <div style={{ marginRight: 15 }} className="reset_button" onClick={() => { this.handleReset() }}>
              {locale === 'EN' ? 'Reset' : '重置'}
            </div>
            <div className="export_button" onClick={() => { this.handleExport() }}>
              <ExportOutlined className="icon" />
              {locale === 'EN' ? 'Export Data' : '导出'}
            </div>
          </div>

          {this.renderTable()}
        </div>
      </BasicLayout>
    )
  }
}

export default connect(({ gameList, user }) => ({
  list: gameList.list,
  page: gameList.page,
  perPage: gameList.perPage,
  pageLoading: gameList.pageLoading,
  followedStatus: gameList.followedStatus,
  developerList: gameList.developerList,
  segmentList: gameList.segmentList,
  genreList: gameList.genreList,
  userInfo: user.userInfo,
  locale: user.locale
}))(GameList)
